import PageBlogPost from "./pageBlogPost";
import PageGenericPage from "./pageGenericPage";

const Page = (props: any) => {
  if (props && props.pageContentType) {
    switch (props.pageContentType) {
      case "pageGenericPage":
        return <PageGenericPage {...props} />;

        case "pageBlogIndex":
          return <PageGenericPage {...props} />;
      case "pageBlogPost":
        return <PageBlogPost {...props} />;
      default:
        return <PageGenericPage {...props} />;
    }
  }

  return <PageGenericPage {...props} />;
};

export default Page;
